import React, { useState, useEffect } from 'react'
import { APP_TIMEZONE } from '../../utils/constants/formInitialStates';

export const CandaTimeZone = () => {

    // const getCurrentTimeCanada = () => {
    //     const currentTime = new Date();

    //     const options = {
    //         timeZone: APP_TIMEZONE,
    //         hour12: true,
    //         hour: 'numeric',
    //         minute: 'numeric',
    //         // second: 'numeric',
    //         year: '2-digit',
    //         month: 'short',
    //         day: 'numeric',
    //     }

    //     let canadaTime = currentTime.toLocaleString('en-US', options);  
    //     canadaTime = canadaTime.replace(', ', ' ').replace(' at ', ' , ');

    //     return canadaTime;
    // }

    const getCurrentTimeCanada = () => {
        const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: APP_TIMEZONE,
            day: "2-digit",
            month: "short",
            year: "2-digit",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        }).formatToParts(new Date());

        const day = parts.find((part) => part.type === "day")?.value ?? "";
        const month = parts.find((part) => part.type === "month")?.value ?? "";
        const year = parts.find((part) => part.type === "year")?.value ?? "";
        const hour = parts.find((part) => part.type === "hour")?.value ?? "";
        const minute = parts.find((part) => part.type === "minute")?.value ?? "";
        const dayPeriod = parts.find((part) => part.type === "dayPeriod")?.value?.toUpperCase() ?? "";

        return `${day} ${month} ${year}, ${hour}:${minute} ${dayPeriod}`;
    }
    

    const DisplayCurrentTime = () => {
        const currentCanadaTime = getCurrentTimeCanada();
        setCurrentDateAndTime(currentCanadaTime);
    }
    const [currentDateAndTime, setCurrentDateAndTime] = useState(getCurrentTimeCanada);

    useEffect(() => {
        const interval = setInterval(DisplayCurrentTime, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <React.Fragment>
            <button  className="h-12  text-white font-medium rounded-sm text-sm text-center  1376px:flex hidden  items-center justify-center " type="button">
                {currentDateAndTime}
            </button>
        </React.Fragment>
    )
}
